module.exports = __webpack_public_path__ + "images/f3539f4f84de1cd9223da4be102f8b88.png";